import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {map} from 'rxjs/operators';
import {IDimensao} from '../models/dimensao.model';

const dimensoes: IDimensao[] = [
  {id: 0, nome: 'equipe', caption: 'Equipe (Mão de Obra)'},
  {id: 1, nome: 'produto', caption: 'Produto (Material)'},
  {id: 2, nome: 'processo', caption: 'Processo (Método)'},
  {id: 3, nome: 'preco', caption: 'Preço (Medida)'},
  {id: 4, nome: 'loja', caption: 'Loja (Máquina de Vendas)'},
  {id: 5, nome: 'meio_ambiente', caption: 'Meio Ambiente'}
];

@Injectable()
export class DimensoesService {

  getDimensoes(): Observable<IDimensao[]> {
    return Observable.from(dimensoes)
      .pipe(map(data => {
        return <IDimensao>data;
      }))
      .toArray();
  }
}
